import { getShareholder, ShareholderPage } from "api"
import { getSiteIdByLocale } from "api/SiteId"
import { AxiosResponse } from "axios"
import ShareHolders from "components/shareHolders/ShareHolders"
import { GetStaticProps } from "next"
import { NextSeo } from "next-seo"

export type DataShareHoldersContentProps = {
  title: string
  description: string
  shareholders: {
    [company: string]: string
  }
  date: string
}

type ShareHoldersProps = {
  shareHolders: ShareholderPage //to modify
}

export const getStaticProps: GetStaticProps<ShareHoldersProps> = async ({
  locale,
}) => {
  const siteId = getSiteIdByLocale(locale)
  const shareHolders: AxiosResponse<ShareholderPage, any> =
    await getShareholder(siteId)

  return {
    props: {
      messages: (await import(`../../../messages/${locale}.json`)).default,
      shareHolders: shareHolders.data,
    },
    revalidate: 60,
  }
}

const shareholders = ({ shareHolders }: ShareHoldersProps) => {
  return (
    <>
      <NextSeo
        title={shareHolders?.metaTitle}
        description={shareHolders?.metaDescription}
        additionalMetaTags={[
          { name: "keywords", content: shareHolders?.metaKeywords },
        ]}
        openGraph={{
          title: shareHolders?.ogTitle || shareHolders?.metaTitle,
          description:
            shareHolders?.ogDescription || shareHolders?.metaDescription,
          images: [{ url: shareHolders?.ogImage?.media?.publicUrl || "" }],
        }}
      />
      <ShareHolders shareHoldersData={shareHolders} />
    </>
  )
}

export default shareholders
